import { styled } from '@linaria/react';
import type { GraphData } from '../../api/process-client/process-client.type';
import i18n from '../../base-dictionary';
import { skyDark, skyLight, skyTight } from '../../styles/design-tokens';
import { Text } from '../../ui-library/typography/typography';

type Props = {
  graphData: GraphData | undefined;
};

const ProcessOverviewTile = ({ title, description, value }: { title: string; description: string; value: string }) => {
  return (
    <Tile>
      <Text weight="medium">{title}</Text>
      <Text color={skyDark} size="small" style={{ textAlign: 'center' }}>
        {description}
      </Text>
      <Text size="large" weight="bold" style={{ marginTop: '16px' }}>
        {value}
      </Text>
    </Tile>
  );
};

export const ProcessOverview = ({ graphData }: Props) => {
  const workUnitsName = i18n.t('common.work_units');
  const workUnitsNameLower = workUnitsName.toLowerCase();
  return (
    <TileContainer>
      <ProcessOverviewTile
        title={`Total ${workUnitsName}`}
        description={`Total number of ${workUnitsNameLower} considered`}
        value={`${graphData?.task_count || 0}`}
      />
      <ProcessOverviewTile
        title="Out of Workflow"
        description={`% of ${workUnitsNameLower} that skipped a workflow step`}
        value={`${graphData?.metrics?.skipped_tasks || 0}%`}
      />
      <ProcessOverviewTile
        title="Backwards Steps"
        description={`% of ${workUnitsNameLower} that went backwards`}
        value={`${graphData?.metrics?.backwards_tasks || 0}%`}
      />
      <ProcessOverviewTile
        title="Waiting"
        description={`% of ${workUnitsNameLower} that enter a waiting status`}
        value={`${graphData?.metrics?.blocked_tasks || 0}%`}
      />
    </TileContainer>
  );
};

const TileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
`;

const Tile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${skyLight};
  border-radius: 16px;
  padding: 16px;
  background-color: ${skyTight};
  flex: 1 1 0;
  min-width: 200px;
  box-sizing: border-box;
`;
